import {Dispatch} from 'redux'
import {apprenticeUpdated} from './apprentice/apprenticeReducer'
import {employeeUpdated} from './employee/employeeReducer'

import {personUpdated} from './person/personReducer'
import {UserAccountType} from '../../model/enums/enums'
import {Apprentice, Person} from '../../model/person.model'

/**
 * update the person according to it's type
 * @param {Person | Apprentice} personToUpdate
 * @param {Dispatch} dispatcher
 */
export const updatePersonInStore = (
  personToUpdate: Person | Apprentice,
  dispatcher: Dispatch
) => {
  const userType: UserAccountType | undefined =
    personToUpdate.user_account_type

  switch (userType) {
    case UserAccountType.NoAccount:
      dispatcher(personUpdated(personToUpdate))
      break
    case UserAccountType.Apprentice:
      dispatcher(apprenticeUpdated(personToUpdate))
      break
    case UserAccountType.Praxisbildner:
    case UserAccountType.Berufsbildner:
    case UserAccountType.Admin:
      dispatcher(employeeUpdated(personToUpdate))
      break
    default:
      console.warn(
        'user account type not known, can not update the person in the store!'
      )
  }
}